<div
  [class]="showHeaderFooter ? 'container' : ''"
  [style.font-size]="!showHeaderFooter ? '12px' : null"
>
  <app-header *ngIf="showHeaderFooter"></app-header>
  <app-navbar *ngIf="showHeaderFooter"></app-navbar>
  <main>
    <app-loader />
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="showHeaderFooter"></app-footer>
</div>

